// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Notification_notification__gOal- {
  position: absolute;
  top: 0px;
  z-index: 5;
  padding: 15px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 32px 64px rgba(0, 0, 0, 0.16), 0px 2px 24px rgba(51, 51, 51, 0.15);
}

.Notification_large__OsX7r {
  width: 100%;
}

.Notification_close__F7va0 {
  position: absolute;
  right: 15px;
  width: 25px;
}

.Notification_notification-container__-S690 {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1080px;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}

.Notification_with-top__fwzbT {
  z-index: 1;
  top: 270px;
}

.Notification_without-top__W6pCy {
  z-index: 1;
  position: fixed;
  top: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Notification/Notification.module.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,yBCCM;EDAN,kBAAA;EACA,kFAAA;AAFF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AAHF;;AAMA;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,UAAA;EACA,UAAA;AAHF;;AAMA;EACE,UAAA;EACA,eAAA;EACA,QAAA;AAHF","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.notification {\n  position: absolute;\n  top: 0px;\n  z-index: 5;\n  padding: 15px;\n  background-color: colors.$white;\n  border-radius: 8px;\n  box-shadow: 0px 32px 64px rgba(0, 0, 0, 0.16),\n    0px 2px 24px rgba(51, 51, 51, 0.15);\n}\n\n.large {\n  width: 100%;\n}\n\n.close {\n  position: absolute;\n  right: 15px;\n  width: 25px;\n}\n\n.notification-container {\n  width: 80%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 1080px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.with-top {\n  z-index: 1;\n  top: 270px;\n}\n\n.without-top {\n  z-index: 1;\n  position: fixed;\n  top: 0px;\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notification": `Notification_notification__gOal-`,
	"large": `Notification_large__OsX7r`,
	"close": `Notification_close__F7va0`,
	"notification-container": `Notification_notification-container__-S690`,
	"with-top": `Notification_with-top__fwzbT`,
	"without-top": `Notification_without-top__W6pCy`
};
export default ___CSS_LOADER_EXPORT___;
